module.exports = __webpack_public_path__ + "static/media/amazon.db1da0f4.jpg";